import React from 'react';
import { Orgs } from '/imports/api/orgs';
import { strings } from '/imports/strings';
import { Publications } from '/imports/publications';
import { useFindOne, useFind, useSubscribed, useUser } from '/imports/hooks';
import { RichSelect } from '/imports/ui/RichSelect';
import { Avatar } from '/imports/ui/Avatar';
import { setOrgId } from '/imports/api/users';

const orgSelectClasses = [
  'flex rounded-input border border-grey-6 p-2 h-6',
  '[&_input]:bg-transparent [&_input]:border-none! [&_input]:py-[0.2rem]! [&_input]:px-0! [&_input]:cursor-pointer [&_input]:text-grey-2',
  '[&_input::placeholder]:text-grey-2 [&_input::placeholder]:relative [&_input::placeholder]:top-[-0.15rem]',
  '[&_input:focus]:border-none [&_input:focus]:outline-none',
  '[&_input:disabled]:bg-page-alt',
  '[&_.avatar]:mr-2',
  '[&_.rich-select_input]:min-h-0',
  '[&_.options]:text-grey-2 [&_.options]:z-[3]',
].join(' ');

export const OrgSelect = () => {
  const user = useUser();
  const orgsLoading = useSubscribed(Publications.listMyOrgs);
  const orgs = useFind(() => Orgs.find(), [orgsLoading]);
  const orgId = user?.orgId;
  const org = useFindOne(() => Orgs.find({ _id: orgId }), [orgId, orgsLoading]);
  const handleSetOrgId = async (orgId: string) => {
    await setOrgId.call(orgId);
    window.location.href = '/';
    window.location.reload();
  };
  if (orgsLoading) return null;
  return (
    <div className={`org-select ${orgSelectClasses}`} onClick={(e: any) => e.stopPropagation()}>
      <Avatar url={org?.avatar?.url} fallback={org?.name?.substring(0, 1)} size="1.5rem" />
      <RichSelect
        className="rich-select"
        placeholder={org?.name || strings.ChooseOrganizationFirst()}
        options={orgs.map((o) => {
          return { value: o._id, label: o.name || o._id };
        })}
        onChange={(option) => handleSetOrgId(option.value)}
        clearable={false}
        disabled={org && orgs.length === 1}
      />
    </div>
  );
};
